module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Envoi du document à transmettre au client")]), _vm._v(" "), (_vm.values) ? _c('div', {
    staticClass: "light-frame",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "16px 16px"
    }
  }, [_c('div', {
    staticClass: "md-headline"
  }, [_vm._v(_vm._s(_vm.values.id_user_prenom) + " " + _vm._s(_vm.values.id_user_nom))]), _vm._v(" "), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.values.id_user_adress_street) + ", " + _vm._s(_vm.values.id_user_adress_city) + ", " + _vm._s(_vm.values.id_user_adress_country))]), _vm._v(" "), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.values.id_user_mail))]), _vm._v(" "), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.values.id_user_phnum))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.uploadingFiles), function(percent, name) {
    return _c('div', [_vm._v("\n      Téléchargement de " + _vm._s(name) + " : " + _vm._s(percent) + "%\n    ")])
  }), _vm._v(" "), (_vm.documentReady) ? _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px",
      "color": "white",
      "background-color": "red"
    }
  }, [_c('div', {
    staticClass: "md-headline"
  }, [_vm._v("Dossier déjà validé")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.onClickUpload($event)
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    },
    on: {
      "click": function($event) {
        return _vm.fileInputClick($event)
      },
      "change": function($event) {
        return _vm.fileInputChange($event)
      }
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary large-button",
    attrs: {
      "disabled": _vm.loading
    }
  }, [_vm._v("Envoyer DOCX Corrigé")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_vm._v("OU")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary large-button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onClickConfirm()
      }
    }
  }, [_vm._v("Valider Doc Sans Correction")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41aac691","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Review.vue
// module id = 731
// module chunks = 3